import { apiCallBegan } from "./api";
import { createSlice } from "@reduxjs/toolkit";
import { createSelector } from "reselect";

const slice = createSlice({
  name: "logoandcolor",
  initialState: {
    currentTheme: [],
    currentLogo: "",
  },
  reducers: {
    themeReceiving: (logoandcolor, action) => {
      logoandcolor.currentTheme = [];
    },
    themeReceived: (logoandcolor, action) => {
      logoandcolor.currentTheme = action.payload ? action.payload : "";
    },
    themeRetrievalFailed: (logoandcolor, action) => {
      logoandcolor.currentTheme = [];
    },
    logoReceived: (logoandcolor, action) => {
      logoandcolor.currentLogo = action.payload ? action.payload : "";
    }, 
    logoRetrievalFailed: (logoandcolor, action) => {
      logoandcolor.currentLogo = "";
    } 
  },
});

export const {
  themeReceiving,
  themeReceived,
  themeRetrievalFailed,
  logoReceived,
  logoRetrievalFailed
} = slice.actions;

export default slice.reducer;

// SAVE USER THEME
export const saveUserColor = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "api/logoandcolor/save",
    method: "post",
    data: data,
  });

// GET USER THEME   
export const getCurrentTheme = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "api/logoandcolor/",
    method: "post",
    data: data,
    onStart: themeReceiving.type,
    onSuccess: themeReceived.type,
    onError: themeRetrievalFailed.type,
  });

// SAVE LOGO
export const saveLogo = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "api/logoandcolor/uploadlogo",
    method: "post",
    data: data,
  });

// GET LOGO
export const fetchLogo = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "api/logoandcolor/getlogo",
    method: "post",
    data: data,
    onSuccess: logoReceived.type,
    onError: logoRetrievalFailed.type,
  });

export const getTheme = createSelector(
    (state) => state.entities.logoandcolor,
    (logoandcolor) => logoandcolor.currentTheme,
  );

export const getLogoSelector = createSelector(
    (state) => state.entities.logoandcolor,
    (logoandcolor) => logoandcolor.currentLogo,
  );